import { Component, Inject } from '@angular/core';
import { Complaint, ComplaintPosition, DocumentAttachment } from '@icc/b2b/shared';
import { DIALOG_DATA, DialogRef } from '@icc/ui';
import { ComplaintService } from '../complaint.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ConfigService } from '@icc/shared';

@Component({
    selector: 'icc-complaint-document-preview',
    templateUrl: './complaint-document-preview.component.html',
    styleUrls: ['./complaint-document-preview.component.scss'],
})
export class ComplaintDocumentPreviewComponent {
    positionsTitles = new Map<string, string[]>();

    constructor(
        private dialogRef: DialogRef,
        @Inject(DIALOG_DATA)
        public data: {
            document: Complaint;
            positions: ComplaintPosition[];
            attachments: DocumentAttachment[];
        },
        private sanitizer: DomSanitizer,
        private complaintService: ComplaintService,
        private configService: ConfigService
    ) {
        const showFullPositionTitles = this.configService.user?.user?.ActiveCompanyLicenseType === 'license';
        this.data.document.consents.forEach((consent) => {
            consent.shortDescription = this.sanitizer.bypassSecurityTrustHtml(consent.shortDescription as string);
        });
        this.data.positions.forEach((position) => {
            this.positionsTitles.set(position.uuid, this.complaintService.getPositionTitle(position, showFullPositionTitles));
        });
    }

    close() {
        this.dialogRef.close();
    }
}
